export default function LayoutCentered({ children }) {
  return (
    <div className="flex-1 flex justify-center items-center h-full">
      {children}
    </div>
  );
}